const nameList = new Intl.ListFormat('en', { type: 'conjunction' })

/** Warning for joiners that lose their name because another voice in the room keeps it. */
export const droppedVoiceNamesWarning = (names: readonly string[]): string => {
  const quoted = nameList.format(names.map((name) => `“${name}”`))
  return names.length === 1
    ? `Another voice in this room keeps the name ${quoted}, so this speaker is added without it.`
    : `Other voices in this room keep the names ${quoted}, so these speakers are added without them.`
}
